import {lazy} from 'react'

const LegalPageScreen = lazy(
  () => import(/* webpackChunkName: 'legalPage' */ './LegalPageScreen'),
)

export {LegalPageScreen}
